import { Injectable } from '@angular/core';
import { HttpService } from '../../utils/services/http.service';
import { Observable } from 'rxjs/Observable';
import { ErrorsService } from '../../utils/services/errors.service';

@Injectable()
export class NonComplianceListService {

  constructor(
    public httpService: HttpService,
    private errorsService: ErrorsService
  ) { }

  /**API get method to fetch locked employee list*/
  getLockedList(): Observable<any> {
    return this.httpService.get(`employee/list/NonCompliance`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API request to unlock employee*/
  unLockTimeSheet(employees): Observable<any> {
    const data = {
      'employeeList': employees,
      'isNonCompliance': true
    };
    return this.httpService.post(`employee/unlock`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**Function to handle API error data*/
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/non-compliance-list/non-compliance-list.service.ts